// components/ProductsDetail/CTASection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CTASectionWrapper = styled.section`
  background: #f5f7fa;
  margin-top: 80px;

  @media (max-width: 768px) {
    margin-top: 60px;
  }
`;

const CTAInner = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 5%;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 5%;
  }
`;

const CTATitle = styled.h3`
  margin: 0 0 30px;
  font-size: 18px;
  font-weight: 600;
  color: #111;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CTAButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  border-radius: 6px;
  background: #005bac;
  color: #ffffff;
  font-weight: 700;
  font-size: 15px;
  text-decoration: none;

  &:hover {
    opacity: 0.9;
  }
`;

const CTASection = () => (
  <CTASectionWrapper>
    <CTAInner>
      <CTATitle>제품에 대해 더 궁금한 점이 있으신가요?</CTATitle>
      <CTAButton to="/community/contact">문의하기</CTAButton>
    </CTAInner>
  </CTASectionWrapper>
);

export default CTASection;
